import { Injectable, InjectionToken, inject } from '@angular/core';
import { SecurityService } from '../../../services/security.service';
import { PreferencesService } from '../../../services/preferences/preferences.service';

export const W8BEN_CONFIGURATION = new InjectionToken<boolean>('w8BenConfiguration');

export interface W8BenConfiguration {
  enabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class W8BenFormInitService {
  private readonly w8BenConfiguration = inject<W8BenConfiguration>(W8BEN_CONFIGURATION, { optional: true });
  private readonly securityService = inject(SecurityService);
  private readonly preferencesService = inject(PreferencesService);

  get w8benEnabled(): boolean {
    return Boolean(this.w8BenConfiguration?.enabled) &&
           this.hasPermission() &&
           this.hasUserPreference();
  }

  get initialModalEnabled(): boolean {
    return this.w8benEnabled;
  }

  private hasPermission(): boolean {
    return this.securityService.hasPermission('W8_BEN') || this.securityService.hasPermission('W8_BEN_LITE');
  }

  private hasUserPreference(): boolean {
    return this.preferencesService.getPreloadedUserPreference<boolean>('W8BEN_INDICATOR') ?? false;
  }
}
